module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Tools/Pink-fafde51fedcb2cb9dab8a9ff9a292b59.svg";